import { Component } from 'preact'

export default class Tabs extends Component {
  constructor () {
    super()

    this.state = {
      activeTab: 0
    }

    this.showTabHandler = this.showTabHandler.bind(this)
  }

  showTabHandler (index, disableClick, event) {
    event.preventDefault()

    if (!disableClick) {
      this.setState({
        activeTab: index
      })
    }
  }

  render (props, state) {
    const { children, titles, style, disableClick } = props
    const { activeTab } = state

    return (
      <div class='sections__nav'>
        <ul class='tabs--navigation qa-profile-tooltip-tabs' style={style}>
          {titles.map((title, index) => (
            <li class='tabs__item qa-tab' onClick={event => this.showTabHandler(index, disableClick, event)}>
              <button
                class={`tabs__btn qa-link-tab ${index === activeTab ? 'tabs__btn--active' : ''}`}
                type='button'
              >
                {title}
              </button>
            </li>
          ))}
        </ul>
        <div class='tabs--navigation'>
          {children.map((child, index) => (
            <div class={`tabs qa-tab-content ${index === activeTab ? 'tabs--active' : ''}`}>
              {child}
            </div>
          ))}
        </div>
      </div>
    )
  }
}
